
































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
import { getColor, getFromSourceText } from "@/libs/colors";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() type!: string;

  dispatchType = "stadium/userPlayer";

  columns: any[] = [
    { title: "编号", dataIndex: "user_id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", dataIndex: "username" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "加入时间", dataIndex: "created_time" },
    { title: "来源", scopedSlots: { customRender: "from_source" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  getColor(fromSource: number): string {
    return getColor(fromSource);
  }

  getFromSourceText(fromSource: number): string {
    return getFromSourceText(fromSource);
  }

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
